<script>
import * as sdk from '../../functions/sdk';
import { store } from '../../functions/mixins';
import UiContainer from '../ui/Container';
import UiHeadline from '../ui/Headline';
import UiInput from '../../components/ui/Input';
import UiButton from '../../components/ui/Button';
import UiLoading from '../../components/ui/Loading';
import UiTabs from '../../components/ui/Tabs';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiHeadline,
        UiInput,
        UiButton,
        UiLoading,
        UiTabs,
    },
    data() {
        return {
            username: '',
            password: '',
            loading: false,
            error: false,
            invalidToken: false,
            currentTab: 'login',
            rUsername: '',
            rPassword: '',
            rRetype: '',
            rLoading: false,
            rError: false,
        };
    },
    created() {
        if (this.isLogged) {
            this.loggingOut = true;
            sdk.accessManagement.logout().then(() => {
                this.loggingOut = false;
            }).catch(() => {
                window.location.reload();
            });
        }
    },
    methods: {
        mergeAccounts(faToken) {
            const { username, password } = this;
            const { token } = this.$route.params;
            this.loading = true;
            this.error = false;
            this.invalidToken = false;
            sdk.firebase.auth().signInWithEmailAndPassword(username, password).then(() => {
                sdk.firebase.auth().currentUser.getIdToken().then(faToken => {
                    sdk.accessManagement.changeFATokenWithToken(token, faToken).then(() => {
                        this.$router.push({name: 'home', query: {
                            enableFirebaseLogin: 'yes',
                        }});
                        this.loading = false;
                    }).catch(() => {
                        // invalid token
                        this.invalidToken = true;
                        this.loading = false;    
                    });
                }).catch(() => {
                    // cant get faToken
                    this.error = true;
                    this.loading = false;
                })
            }).catch(() => {
                // cant login
                this.error = true;
                this.loading = false;
            });
        },
        createAccountAndMerge() {
            const { rUsername, rPassword } = this;
            const { token } = this.$route.params;
            this.rLoading = true;
            this.rError = false;
            this.invalidToken = false;
            sdk.firebase.auth().createUserWithEmailAndPassword(rUsername, rPassword).then(() => {
                sdk.firebase.auth().currentUser.getIdToken().then(faToken => {
                    sdk.accessManagement.changeFATokenWithToken(token, faToken).then(() => {
                        this.$router.push({name: 'home', query: {
                            enableFirebaseLogin: 'yes',
                        }});
                        this.rLoading = false;
                    }).catch(() => {
                        // invalid token
                        this.invalidToken = true;
                        this.rLoading = false;    
                    });
                }).catch(() => {
                    // cant get faToken
                    this.rError = true;
                    this.rLoading = false;
                })
            }).catch(() => {
                // cant login
                this.rError = true;
                this.rLoading = false;
            });
        },
    },
}
</script>

<template>
    <ui-container>
        <ui-headline>{{ $t('initialLogin.pageTitle') }}</ui-headline>
        <div class="TokenError" v-if="invalidToken">
            {{ $t('initialLogin.invalidToken') }}
        </div>
        <template v-else>
            <ui-tabs
                v-model="currentTab"
                :tabs="[
                    {title: $t('initialLogin.tabLogin'), value: 'login'},
                    {title: $t('initialLogin.tabRegister'), value: 'register'},
                ]"
            />
            <form
                :class="['Form', {Error: error}, {Loading: loading}]"
                @submit.prevent="mergeAccounts()"
                v-if="currentTab === 'login'"
            >
                <ui-input
                    v-model="username"
                    :label="$t('initialLogin.labelUsername')"
                    :readonly="loading" 
                    @keydown.native="error = false"
                />
                <ui-input
                    v-model="password"
                    :label="$t('initialLogin.labelPassword')"
                    type="password"
                    :readonly="loading" 
                    @keydown.native="error = false"
                />
                <div class="Controls">
                    <ui-button :disabled="loading">{{ $t('initialLogin.login') }}</ui-button>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </form>
            <form
                :class="['Form', {Error: rError}, {Loading: rLoading}]"
                @submit.prevent="createAccountAndMerge()"
                v-if="currentTab === 'register'"
            >
                <ui-input
                    v-model="rUsername"
                    :label="$t('initialLogin.labelUsername')"
                    :readonly="rLoading" 
                    @keydown.native="rError = false"
                />
                <ui-input
                    v-model="rPassword"
                    :label="$t('initialLogin.labelPassword')"
                    type="password"
                    :readonly="rLoading" 
                    @keydown.native="rError = false"
                />
                <ui-input
                    v-model="rRetype"
                    :label="$t('initialLogin.labelRetypePassword')"
                    type="password"
                    :readonly="rLoading" 
                    @keydown.native="rError = false"
                />
                <div class="Controls">
                    <ui-button :disabled="rLoading">{{ $t('initialLogin.register') }}</ui-button>
                </div>
                <div class="LoadingOverlay">
                    <ui-loading />
                </div>
            </form>
        </template>
    </ui-container>
</template>

<style lang="stylus" scoped>
@import '../../stylus/vars.styl'

.TokenError
    border 1px solid $cError
    background lighten($cError, 80%)
    color $cError
    padding 20px
    margin-bottom 20px
    width 100%
    box-sizing border-box    

.Form
    position relative
    overflow hidden
    .Controls
        margin-top 20px
    .LoadingOverlay
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        background rgba(255,255,255,.5)
        transform translate(0,100%)
        transition .3s all
        display flex
        align-items center
        justify-content center
    &.Error
        border-color $cError
        .Input
            border-color $cError
    &.Loading
        .LoadingOverlay
            transform translate(0,0)
.AddSpace
    margin-top 40px
    height 80px
    display flex
    align-items center
</style>

